import { required, maxLength, minLength, email } from 'vuelidate/lib/validators'
export const recipientValidationsGeneral = {
  document: {
    required
  },
  email: {
    required,
    email,
    maxLength: maxLength(64)
  },
  description: {
    maxLength: maxLength(256)
  },
  phone_numbers: {
    ddd: {
      minLength: minLength(2)
    },
    number: {
      minLength: minLength(8),
      maxLength: maxLength(30)
    },
    type: {
      required
    }
  },
  site_url: {
    maxLength: maxLength(128)
  }
}
export const address = {
  street: {
    required,
    maxLength: maxLength(128)
  },
  complement: {
    maxLength: maxLength(128)
  },
  number: {
    required,
    maxLength: maxLength(10)
  },
  neighborhood: {
    required,
    maxLength: maxLength(128)
  },
  city: {
    required,
    maxLength: maxLength(128)
  },
  state: {
    required,
    maxLength: maxLength(2)
  },
  zip_code: {
    required,
    maxLength: maxLength(9)
  },
  reference_point: {
    maxLength: maxLength(128)
  }
}
export const personalUser = {
  ...recipientValidationsGeneral,
  name: {
    required,
    minLength: minLength(3),
    maxLength: maxLength(128)
  }
}

export const corporationUser = {
  ...recipientValidationsGeneral,
  company_name: {
    required,
    maxLength: maxLength(128)
  },
  trading_name: {
    required,
    maxLength: maxLength(128)
  },
  annual_revenue: {
    required
  },
  founding_date: {
    required
  }
}

export const managingPartners = {
  ...personalUser,
  birth_date: {
    required
  },
  mother_name: {
    required,
    maxLength: maxLength(128)
  },
  monthly_income: {
    required
  },
  professional_occupation: {
    required,
    maxLength: maxLength(128)
  }
}

export const defaultBankAccountValidations = {
  bank: {
    required,
    maxLength: maxLength(3),
    minLength: minLength(3)
  },
  branch_number: {
    required,
    maxLength: maxLength(4)
  },
  branch_check_digit: {
    maxLength: maxLength(1)
  },
  account_number: {
    required,
    maxLength: maxLength(13)
  },
  account_check_digit: {
    required,
    maxLength: maxLength(2)
  },
  holder_name: {
    required,
    maxLength: maxLength(30)
  },
  holder_document: {
    required
  }
}

export const prepaymentValidations = {
  volume_percentage: {
    required,
    maxLength: maxLength(3),
    lessThan: value => value <= 100
  },
  delay: {
    required
  },
  type: {
    required
  }
}

export const transferSettingsValidations = {
  transfer_day: {
    lessThan: value => value <= 31,
    biggerThan: value => value >= 1
  },
  transfer_interval: {
    required
  }
}
